export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="text-center">
        <div className="text-3xl mb-3 animate-pulse">🍷</div>
        <div className="text-t-secondary text-sm">読込中...</div>
      </div>
    </div>
  );
}
